import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../hooks/useSeo";
import { Reveal } from "../components/motion/Reveal";
import { SunIcon } from "../components/brand/icons";

export default function PressPage() {
  const [items, setItems] = useState([]);

  useSeo({
    title: "Recent Press | Pantheon Art",
    description: "Press coverage of Pantheon Art and its artists.",
    path: "/press",
  });

  useEffect(() => {
    api
      .get("/press")
      .then((res) => setItems(res.data || []))
      .catch(() => {});
  }, []);

  return (
    <div className="px-5 pb-24 pt-32 lg:px-10 lg:pt-40" data-testid="press-page">
      <Reveal>
        <p className="eyebrow mb-4">Coverage</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h1 className="h-condensed text-[clamp(3rem,8vw,7rem)]">Recent Press</h1>
      </Reveal>

      <div className="hairline-t mt-12 grid gap-x-8 gap-y-16 pt-12 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item, i) => (
          <Reveal key={item.id || i} delay={(i % 3) * 0.1}>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`press-tile-${i}`}
              className="group block"
            >
              <div className="flex aspect-[4/3] items-center justify-center overflow-hidden bg-stone-40">
                {item.thumbnail ? (
                  <img
                    src={item.thumbnail}
                    alt={item.headline}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
                  />
                ) : (
                  <SunIcon className="h-12 w-12 opacity-70" />
                )}
              </div>
              <p className="eyebrow mt-5 text-[0.65rem]">{item.publication}</p>
              <h3 className="mt-2 font-grotesk text-lg font-light uppercase leading-snug tracking-wide">
                {item.headline}
              </h3>
            </a>
          </Reveal>
        ))}
      </div>
      {items.length === 0 && (
        <p className="body-text mt-16" data-testid="press-empty">
          Press items will appear here soon.
        </p>
      )}
    </div>
  );
}
